import classNames from "classnames";
import { rest } from "lodash";
import { HTMLProps } from "react";

export function BoxItem(
	props: {
		bgColor: "semidark" | "dark";
		padding?: "p-0" | "p-1" | "p-2" | "p-3" | "p-4";
		customRef?: React.Ref<HTMLDivElement>;
		no_border?: boolean;
	} & HTMLProps<HTMLDivElement>
) {
	let { bgColor, padding, customRef, no_border, ...rest } = props;

	padding = props.padding ?? "p-4";

	return (
		<div
			{...rest}
			ref={props.customRef}
			className={classNames(
				"flex",
				{
					border: !no_border,
					"border-base-dark bg-base-semidark":
						props.bgColor === "semidark",
					"border-base-light bg-base-dark": props.bgColor === "dark",
					"p-0": padding === "p-0",
					"p-1": padding === "p-1",
					"p-2": padding === "p-2",
					"p-3": padding === "p-3",
					"p-4": padding === "p-4",
				},
				props.className
			)}
		>
			{props.children}
		</div>
	);
}
